import React, { useState } from "react";
import Select from "react-select";

const BulkUpdateModal = ({ isOpen, onClose, onUpdate, users }) => {
    const [assignedTo, setAssignedTo] = useState("");
    const [dueDate, setDueDate] = useState("");
    const userOptions = users.map((u) => ({
        value: u.id,
        label: u.userName,
    }));

    const handleUpdate = () => {
        if (!assignedTo) {
            alert("Please select a user to assign to.");
            return;
        }

        onUpdate({ assignedTo, dueDate });
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
            <div className=" rounded-lg shadow-lg  w-full max-w-md bg-[#FFFFFF] p-6 ">
                <h2 className="text-lg font-bold mb-4">Bulk Update Tasks</h2>

                <div className="mb-4">
                    <label className="block mb-1 font-medium">Assign To</label>
                    <Select
                        className="text-black"
                        classNamePrefix="react-select"
                        options={userOptions}
                        value={userOptions.find((option) => option.value === assignedTo) || null}
                        onChange={(selectedOption) => setAssignedTo(selectedOption?.value || null)}
                        isClearable
                        placeholder="Select a user"
                    />
                </div>

                <div className="mb-4">
                    <label className="block mb-1 font-medium">Due Date</label>
                    <input
                        type="date"
                        className="w-full border border-gray-300 rounded px-3 py-2"
                        value={dueDate}
                        onChange={(e) => setDueDate(e.target.value)}
                    />
                </div>

                <div className="flex justify-end gap-2">
                    <button
                        className="px-4 py-2 bg-gray-300 text-black rounded hover:bg-gray-400"
                        onClick={onClose}
                    >
                        Cancel
                    </button>
                    <button
                        className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
                        onClick={handleUpdate}
                    >
                        Update
                    </button>
                </div>
            </div>
        </div>
    );
};

export default BulkUpdateModal;
